import { render, staticRenderFns } from "./DocHubResourceGroupForm.vue?vue&type=template&id=58fc26b1"
import script from "./DocHubResourceGroupForm.vue?vue&type=script&lang=js"
export * from "./DocHubResourceGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports